import Vue from 'vue';
import Router from 'vue-router';

// split code
const Index = r => require.ensure([], () => r(require('@/www/pages/Index')));
const Download = r => require.ensure([], () => r(require('@/www/pages/Download')));
const Subscribe = r => require.ensure([], () => r(require('@/www/pages/Subscribe')));
const News = r => require.ensure([], () => r(require('@/www/pages/News')));
const Charge = r => require.ensure([], () => r(require('@/www/pages/Charge')));
const Talkshow = r => require.ensure([], () => r(require('@/www/pages/Talkshow')));
const Speech = r => require.ensure([], () => r(require('@/www/pages/Speech')));
const University = r => require.ensure([], () => r(require('@/www/pages/University')));

Vue.use(Router);
const route = new Router({
    mode: 'history',
    routes: [
        {
            path: '/pc',
            name: 'Index',
            component: Index,
        },
        {
            path: '/pc/download',
            name: 'Download',
            component: Download,
        },
        {
            path: '/pc/charge',
            name: 'Charge',
            component: Charge,
        },
        {
            path: '/pc/news',
            name: 'News',
            component: News,
        },
        {
            path: '/pc/subscribe',
            name: 'Subscribe',
            component: Subscribe,
        },
        {
            path: '/pc/talkshow',
            name: 'Talkshow',
            component: Talkshow,
        },
        {
            path: '/pc/speech',
            name: 'Speech',
            component: Speech,
        },
        {
            path: '/pc/university',
            name: 'University',
            component: University,
        }
    ]
})
route.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})
export default route



// WEBPACK FOOTER //
// ./client/www/router/index.js